import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { checkRouteProperty } from '@/routes/Routes.helpers';
import { privateRoutes } from '@/routes/Routes.private.config';
import { publicRoutes } from '@/routes/Routes.public.config';
import { serviceRoutes } from '@/routes/Routes.service.config';

const allRoutes = { ...privateRoutes, ...publicRoutes, ...serviceRoutes };

export const useRouteProperties = (): {
    isHideHeader: boolean;
    isShowTabBar: boolean;
    isPrivateRoute: boolean;
} => {
    const { pathname } = useLocation();

    const isHideHeader = useMemo(
        () => checkRouteProperty(allRoutes, pathname, 'hideHeader') ?? false,
        [pathname],
    );

    const isShowTabBar = useMemo(
        () => checkRouteProperty(allRoutes, pathname, 'showTabBar') ?? false,
        [pathname],
    );

    const isPrivateRoute = useMemo(
        () => checkRouteProperty(privateRoutes, pathname, 'path') ?? false,
        [pathname],
    );

    return {
        isHideHeader,
        isShowTabBar,
        isPrivateRoute,
    };
};
